/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Absence } from './Absence';
import {
    AbsenceFromJSON,
    AbsenceFromJSONTyped,
    AbsenceToJSON,
    AbsenceToJSONTyped,
} from './Absence';

/**
 * 
 * @export
 * @interface ShowAbsenceResponse
 */
export interface ShowAbsenceResponse {
    /**
     * 
     * @type {Absence}
     * @memberof ShowAbsenceResponse
     */
    data: Absence;
}

/**
 * Check if a given object implements the ShowAbsenceResponse interface.
 */
export function instanceOfShowAbsenceResponse(value: object): value is ShowAbsenceResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowAbsenceResponseFromJSON(json: any): ShowAbsenceResponse {
    return ShowAbsenceResponseFromJSONTyped(json, false);
}

export function ShowAbsenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowAbsenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AbsenceFromJSON(json['data']),
    };
}

  export function ShowAbsenceResponseToJSON(json: any): ShowAbsenceResponse {
      return ShowAbsenceResponseToJSONTyped(json, false);
  }

  export function ShowAbsenceResponseToJSONTyped(value?: ShowAbsenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AbsenceToJSON(value['data']),
    };
}

